import { Routes } from '@angular/router';
import { HelpListComponent } from '@help/help-list/help-list.component';
import { HelpDetailComponent } from '@help/help-detail/help-detail.component';

export const HelpRoutes: Routes = [
  {
    path: '',
    component: HelpListComponent,
    data: { titleKey: 'routes.help' },
  },
  {
    path: ':helpId',
    component: HelpDetailComponent,
    data: { titleKey: 'routes.help' },
  },
];
